import axios from 'axios';

const baseUrl = process.env.REACT_APP_BACKEND_DOMAIN;

export default class Game {

  static endpoints = {
    index: `${baseUrl}/games`,
  };

  static checkLimitedGame(item, limits) {

    if (item.usersPaymentLimit > limits.acceptedCashouts)                            return 1;
    if(item.limitPoints > limits.userPoints)                                         return 2;
    if(item.daysLimit > limits.accCreatedDays)                                       return 3;
    if(item.tokensCostPerGame && (limits.availableTokens < item.tokensCostPerGame) ) return 4;
    return 0;
  };

  static getLimititationSentence(item, limits) {
    switch(this.checkLimitedGame(item, limits)){
      case 1 : return (<p>In order to play, you are required to have a minimum of <strong>{item.usersPaymentLimit}</strong> approved cashouts.</p>);
      case 2 : return (<p>To play, you must accumulate a minimum of <strong>{item.limitPoints}</strong> points from surveys or offers.</p>);
      case 3 : return (<p>Before you can start playing, you’ll need to wait for a minimum of <strong>{item.daysLimit - limits.accCreatedDays}</strong> days.</p>);
      case 4 : return (<p>In order to unlock and play the game, you must have a minimum of <strong>{item.tokensCostPerGame}</strong> tokens to be able to play.</p>)
      default: return;
    }
  }

  static paginators = {
    all: (data)=> axios.get(this.endpoints.index, {params: data}).then((response)=> response.data.games.items),
  };

  static getPlayUrl(gameId) {
    return axios.get(`${this.endpoints.index}/play-url/${gameId}`).then((response)=> response.data.url);
  };

  static getRank(dateOffset, gameId) {
    return axios.post(`${this.endpoints.index}/rank/${gameId}`, {dateOffset}).then((response)=> response.data);
  };

  static getRecordData(gameId) {
    return axios.get(`${this.endpoints.index}/record-data/${gameId}`).then((response)=> response.data);
  };

  static getGamesKey(gameId) {
    return axios.get(`${this.endpoints.index}/game-key/${gameId}`).then((response)=> response.data);
  };
};
